<template>
  <div class="minHeight" v-if="isLoading">
    <Loader />
  </div>
  <div v-else class="exclusive-wrapper minHeight">
    <div v-if="bannerPlaceHolderForNewExclusiveRevamp">
      <exclusive-revamp />
      <exclusive-modal v-if="isNotifyVisible" :addExclusive="addExclusive" :togglePopup="togglePopup" :exclusiveAdded="exclusiveAdded" :removeExcFromCart="removeExcFromCart" />
      <notify-modal v-if="isNotifyVisible && this.now < this.launchDate" :notify="notify" />
    </div>
    <div v-else>
      <BannerPlaceHolderMsg
        v-if="bannerPlaceHolderExc && bannerPlaceHolderExc.status" 
        :bannerStyle="bannerPlaceHolderExc && bannerPlaceHolderExc.styles"
        :bannerMsg="bannerPlaceHolderExc && bannerPlaceHolderExc.text"
      >
      </BannerPlaceHolderMsg>
      <div v-if="exclusiveUser && exclusiveDetails && exclusiveDetails.expire_in >= 0" class="exc-section-one-wrapper is_Desktop">
        <div class="exc-mem-section-one container-fluid">
          <div class="row">
            <div class="col-12">
              <div class="fbold userHead">
                <p class="exc-mem-name">
                  {{username}}
                  <img data-src="https://tss-static-images.gumlet.io/icons/userCrown.png" class="crownImgMain" alt="Crown"/>
                </p>
              </div>
              <div class="total-savings-div">
                <p class="total-savings">Total {{(memberSavingsTxt && memberSavingsTxt.tag_text) || 'Member Savings'}} Till Now: {{ currencySymbol }}{{exclusiveDetails.exclusive_savings}}</p>
              </div>
            </div>
          </div>
          <div class="row exc-mem-info">
            <div class="col-6">
              <div class="row">
                <div class="col-12">
                  <p v-if="exclusiveDetails.membership_type === 'MONTHLY'" class="exc-active-plan">Active plan : 1 Month</p>
                  <p v-else-if="exclusiveDetails.membership_type === 'ANNUAL'" class="exc-active-plan">Active plan : 12 Months</p>
                  <p v-else class="exc-active-plan">Active plan : 3 Months</p>
                  <p class="exc-member-since">Member since {{exclusiveDetails && exclusiveDetails.exclusive_since && exclusiveDetails.exclusive_since.split(' ')[0]}}<sup>{{exclusiveDetails.exclusive_since_sup}}</sup> {{exclusiveDetails.exclusive_since.split(' ')[1]}} {{exclusiveDetails.exclusive_since.split(' ')[2]}}</p>
                  <p class="exc-plan-valid-till">Plan Valid till {{exclusiveDetails && exclusiveDetails.expiry_date && exclusiveDetails.expiry_date.split(' ')[0]}}<sup>{{exclusiveDetails.expiry_date_sup}}</sup> {{exclusiveDetails.expiry_date.split(' ')[1]}} {{exclusiveDetails.expiry_date.split(' ')[2]}}</p> 
                </div>
              </div>
              <div v-if="exclusiveDetails.show_upgrade_plan && !CHECK_PRODUCT_MATCHES" class="row exc-mem-update-head">
                <div class="col-12">
                  <p class="exc-upgrade-plan">EXTEND YOUR PLAN</p>
                </div>
              </div>
              <div v-if="exclusiveDetails.show_upgrade_plan && !CHECK_PRODUCT_MATCHES" class="row exc-mem-update-div" style="width: 96%">
                <div class="col-7" style="padding-right: 0px !important">
                  <p class="exc-mem-exceede-time">12 months more at just RS <span style="text-decoration: line-through">199</span> 99</p>
                  <!-- <p v-if="exclusiveDetails.membership_type === 'QUARTERLY'" class="exc-mem-exceede-time">9 More Months @ ₹50</p> -->
                </div>
                <div v-if="exclusiveDetails.show_upgrade_plan" class="col-5" style="text-align: end;">
                  <p @click="upgradeMembershipToCart(EXCLUSIVE_PRODUCTS_UPGRADE.prod_id)" class="exc-mem-update-btn">Extend Now</p>
                </div>
              </div>
            </div>
            <div class="col-6">
              <div class="row" style="display: flex; justify-content: center; margin-bottom: 20px">
                <div class="col-6" style="text-align: center;">
                  <p class="exc-days-left-head" style="margin: 0px; line-height: 20px;">Days Left As An</p>
                  <p class="exc-days-left-head" style="margin: 0px">Exclusive Member</p>
                </div>
              </div>
              <div v-if="exclusiveDetails" class="row" style="display: flex; justify-content: center;">
                <div class="col-6" style="text-align: center; position: relative">
                  <circle-counter 
                    size="10rem" 
                    :dash-spacing="0"
                    :stroke-width="8"
                    :active-width="8"
                    :dash-count="100"
                    :stroke="parseInt(exclusiveDetails.expire_in) === parseInt(exclusiveDetails.expire_days) ? '#122643' : '#aba6a6'"
                    active-stroke="#122643"
                    :active-count="(parseInt(exclusiveDetails.expire_in)/parseInt(exclusiveDetails.expire_days))*100"
                    :reverse="false"
                    :text="''">
                  </circle-counter>
                  <p class="exc-days-left">{{exclusiveDetails && exclusiveDetails.expire_in}}</p>
                  <p class="days-left">days left</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="exclusiveUser && exclusiveDetails.expire_in >= 0" class="exc-section-one-wrapper is_Mobile">
        <div class="exc-mem-section-one">
          <div class="row">
            <div class="col-12">
              <div class="fbold userHead">
                <img data-src="https://tss-static-images.gumlet.io/icons/userCrown.png" class="crownImgMain" alt="Crown"/>
                <p class="exc-mem-name">
                  {{username}}
                </p>
              </div>
              <div class="total-savings-div">
                <p class="total-savings">Total {{(memberSavingsTxt && memberSavingsTxt.tag_text) || 'Member Savings'}} Till Now: {{ currencySymbol }}{{exclusiveDetails.exclusive_savings}}</p>
              </div>
            </div>
          </div>
          <div class="row exc-mem-info">
            <div class="col-12">
              <div class="row">
                <div class="col-12">
                  <p v-if="exclusiveDetails.membership_type === 'MONTHLY'" class="exc-active-plan">Active plan : 1 Month</p>
                  <p v-else-if="exclusiveDetails.membership_type === 'ANNUAL'" class="exc-active-plan">Active plan : 12 Months</p>
                  <p v-else class="exc-active-plan">Active plan : 3 Months</p>
                  <p class="exc-member-since">Member since {{exclusiveDetails && exclusiveDetails.exclusive_since && exclusiveDetails.exclusive_since.split(' ')[0]}}<sup>{{exclusiveDetails.exclusive_since_sup}}</sup> {{exclusiveDetails.exclusive_since.split(' ')[1]}} {{exclusiveDetails.exclusive_since.split(' ')[2]}}</p>
                  <p class="exc-plan-valid-till">Plan Valid till {{exclusiveDetails && exclusiveDetails.expiry_date && exclusiveDetails.expiry_date.split(' ')[0]}}<sup>{{exclusiveDetails.expiry_date_sup}}</sup> {{exclusiveDetails.expiry_date.split(' ')[1]}} {{exclusiveDetails.expiry_date.split(' ')[2]}}</p> 
                </div>
              </div>
              <div v-if="exclusiveDetails.show_upgrade_plan && !CHECK_PRODUCT_MATCHES" class="row exc-mem-update-head">
                <div class="col-12">
                  <span class="exc-mem-upgrade-plan">
                    EXTEND YOUR PLAN     
                  </span>
                </div>
              </div>
              <div v-if="exclusiveDetails.show_upgrade_plan && !CHECK_PRODUCT_MATCHES" class="row exc-mem-update-div">
                <div class="col-8">
                  <p class="exc-mem-exceede-time">12 months more at just RS <span style="text-decoration: line-through">199</span> 99</p>
                  <!-- <p v-if="exclusiveDetails.membership_type === 'QUARTERLY'" class="exc-mem-exceede-time">9 More Months @ ₹50</p> -->
                </div>
                <div v-if="exclusiveDetails.show_upgrade_plan" class="col-4" style="text-align: end;">
                  <p @click="upgradeMembershipToCart(EXCLUSIVE_PRODUCTS_UPGRADE.prod_id)" class="exc-mem-update-btn">Extend Now</p>
                </div>
              </div>
            </div>
            <div class="col-12 exc-mem-tracker">
              <div class="row">
                <div class="col-12" style="text-align: start; padding: 10px; margin-bottom: 20px">
                  <p class="exc-days-left-head">Days Left As An Exclusive Member</p>
                </div>
              </div>
              <div v-if="exclusiveDetails" class="row" style="display: flex; justify-content: center;">
                <div class="col-6" style="text-align: center; position: relative">
                  <circle-counter 
                    size="10rem" 
                    :dash-spacing="0"
                    :stroke-width="8"
                    :active-width="8"
                    :dash-count="100"
                    :stroke="parseInt(exclusiveDetails.expire_in) === parseInt(exclusiveDetails.expire_days) ? '#122643' : '#aba6a6'"
                    active-stroke="#122643"
                    :active-count="(parseInt(exclusiveDetails.expire_in)/parseInt(exclusiveDetails.expire_days))*100"
                    :text="''">
                  </circle-counter>
                  <p class="exc-days-left">{{exclusiveDetails && exclusiveDetails.expire_in}}</p>
                  <p class="days-left">days left</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="exclusiveDetails && exclusiveDetails.expire_in < 0 || !exclusiveUser" class="exc-section-one-wrapper">
        <div v-if="isExclusive" class="exc-section-one container-fluid">
          <div class="row click-to-add">
            <div class="col-12">
              <h1 class="sec-one-discount-header">BIG DISCOUNTS</h1>
            </div>
          </div>
          <div class="row click-to-add">
            <div class="col-12">
              <h4 class="sec-one-discount-content">ON ALL PRODUCTS EVERY DAY.</h4>
            </div>
          </div>
        </div>
        <div v-else  class="exc-section-one container-fluid">
          <div class="row click-to-add">
            <div class="col-12">
              <h1 class="sec-one-discount-header">BIG DISCOUNTS</h1>
            </div>
          </div>
          <div class="row click-to-add">
            <div class="col-12">
              <h4 class="sec-one-discount-content">ON ALL PRODUCTS EVERY DAY.</h4>
            </div>
          </div>
        </div>
      </div>
      <div class="container mt40 exclusive-features">
        <div class="row">
          <div class="col-md-5 col-10 text-left">
            <div class="exc-mem-heading">
              <span class="fbold text-left benefitsHeading"> Exclusive Member Benefits
                <img data-src="https://tss-static-images.gumlet.io/icons/crown.png" class="crownImg" alt="Crown"/>
              </span>
            </div>
          </div>
        </div>
        <div class="row mtb20">
          <div class="col-md-6 col-12">
            <div class="row">
              <div class="col-4 col-md-4 eximgDiv">
                <img class="eximg" data-src="https://tss-static-images.gumlet.io/icons/rupeeDiscount.png" alt="Big Discounts">
              </div> 
              <div class="col-8 col-md-7">
                <p class="text-left fbold cHeading">DISCOUNTED PRICES</p>
                <div class="line mb10"><div class="excBenefitCircle"></div></div>
                  <p class="text-left cDesc">
                    BIG discounts on ALL products every day. You never have to wait for a sale again.
                  </p>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-12">
            <div class="row">
              <div class="col-4 col-md-4 eximgDiv">
                <img class="eximg" data-src="https://tss-static-images.gumlet.io/icons/earlyAcc.png" alt="Early Access">
              </div>
              <div class="col-8 col-md-7">
                <p class="text-left fbold cHeading">EARLY  ACCESS</p>
                <div class="line mb10"><div class="excBenefitCircle"></div></div>
                  <p class="text-left cDesc">
                    Be the first to know about select product and designs.
                  </p>
              </div>
            </div>
          </div>
        </div>
        <div class="row mtb20">
          <div class="col-md-6 col-12">
            <div class="row">
              <div class="col-4 col-md-4 eximgDiv">
                <img class="eximg" data-src="https://tss-static-images.gumlet.io/icons/free.png" alt="Free Delivery">
              </div>
              <div class="col-8 col-md-7">
                <p class="text-left fbold cHeading">FREE DELIVERY</p>
                <div  class="line mb10"><div class="excBenefitCircle"></div></div>
                  <p class="text-left cDesc">
                    Your shipping charges are on the house.   
                  </p>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-12">
            <div class="row">
              <div class="col-4 col-md-4 eximgDiv">
                <img class="eximg" data-src="https://tss-static-images.gumlet.io/icons/box.png" alt="Shipping">
              </div>
              <div class="col-8 col-md-7">
                <p class="text-left fbold cHeading">PRIORITISED ORDER <br> PROCESSING </p>
                <div  class="line mb10"><div class="excBenefitCircle"></div></div>
                  <p class="text-left cDesc">
                  We ship your orders before everyone else.
                  </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="exc-section-two-wrapper">
        <div  class="exc-section-two">
          <ExclusiveCard v-if="!isExclusive" :addMembershipToCart="addMembershipToCart" :addExclusive="addExclusive"></ExclusiveCard>
          <div v-if="isExclusive && !exclusiveUser" class="exclusive-congrats-msg">Congratulations, You're a member!</div>
        </div>
      </div>
      <div class="row exc-member-banner">
          <div class="col-12 exc-saving">
            <p class="saving-msg">Average Exclusive Member Savings: {{ currencySymbol }}2,600/ Year</p>
          </div>
      </div>
      <div class="exc-section-three-wrapper" v-if="!exclusiveUser && exclusivePricelist && exclusivePricelist.length > 0">
        <div class="exc-section-three container is_Desktop">
          <div style="padding-bottom: 30px;" class="section-title-wrapper">
            <span class="section-price-comparison" >
              PRICE COMPARISON
            </span>
          </div>
          <carousel :per-page="4" :loop="true" :mouse-drag="true" :autoplay="false" :autoplayTimeout="3000" paginationActiveColor="#e66a51" paginationColor="#646769" class="exc-cat-carousel">
            <slide v-for="(value, index) in this.exclusivePricelist" :key="index" class="exc-cat-slider">
              <ExclusiveCatCards class="exc-cat-card exc-card-desk" :value=value />
            </slide>
          </carousel>
        </div>
        <div class="exc-section-three container is_Mobile" v-if="exclusivePricelist && exclusivePricelist.length > 0">
          <div style="padding-bottom: 30px;" class="section-title-wrapper" id="faqs">
            <span class="section-price-comparison">
              PRICE COMPARISON      
            </span>
          </div>
          <div class="row mobile_carousel">
            <div v-for="(value, index) in this.exclusivePricelist" :key="index">
              <ExclusiveCatCards class="exc-cat-card" :value=value />
            </div>
          </div>
        </div>
      </div>
      <exclusiveAddTOCart :addMembershipToCart="addMembershipToCart" :togglePopup="togglePopup" v-if="!isExclusive"></exclusiveAddTOCart>
      <exclusive-modal v-if="isNotifyVisible" :addExclusive="addExclusive" :togglePopup="togglePopup" :exclusiveAdded="exclusiveAdded" :removeExcFromCart="removeExcFromCart" />
      <notify-modal v-if="isNotifyVisible && this.now < this.launchDate" :notify="notify" />
    </div>
  </div>
</template>

<script>
  var $ = require('jquery')
  window.jQuery = $
  import NotifyModal from './common/NotifyModal.vue'
  import {mapGetters} from 'vuex'
  import Vue from 'vue'
  import {metaElements} from '../assets/js/metaElements'
  // import ExclusiveTicker from '../components/common/ExclusiveTicker.vue'
  import exclusiveAddTOCart from '../components/common/exclusiveAddToCart.vue'
  import ExclusiveCard from '../components/common/ExclusiveCard'
  import ExclusiveModal from './common/ExclusiveModal.vue'
  import ExclusiveCatCards from './common/excCategoryCard.vue'
  import excCategories from './excCategories.json'
  import circleCounter from 'vue-circle-counter'
  import Loader from './common/loader.vue'
  import BannerPlaceHolderMsg from './common/BannerPlaceHolderMsg'
  import getLastPage from '../assets/js/getLastPage'
  import exclusiveRevamp from './exclusive-revamp.vue'
  export default {
    data: function () {
      return {
        launchDate: new Date('2019-03-01 12:00:00'),
        now: new Date(),
        start: new Date(process.env.BIRTHDAY_SALE_START),
        end: new Date(process.env.BIRTHDAY_SALE_END),
        isNotifyVisible: false,
        exclusiveAdded: false,
        initialLimit: 0,
        endlimit: Math.ceil(13 / 4),
        excCategories: excCategories
      }
    },
    mixins: [metaElements],
    beforeDestroy: function () {
      $('body').removeClass('exclusive')
    },
    components: {
      NotifyModal,
      ExclusiveCard,
      exclusiveAddTOCart,
      ExclusiveModal,
      ExclusiveCatCards,
      circleCounter,
      Loader,
      BannerPlaceHolderMsg,
      exclusiveRevamp
    },
    beforeRouteEnter (to, from, next) {
      Vue.ls.set('routeObj',
        {current: getLastPage(to.name), previous: getLastPage(from.name) || ''})
      next()
    },
    created () {
      $('body').addClass('exclusive')
      this.$store.dispatch('SET_NOTIFY_MODAL', true)
      this._setMetaData()
      this.$store.commit('GTAG_EVENT', {eventName: 'ct_page_viewed_custom', payload: {pdp_response: {routeObj: (Vue.ls.get('routeObj')).current}}})
      this.$store.commit('GTAG_EVENT', {eventName: 'Page_Viewed', payload: {pdp_response: {routeObj: (Vue.ls.get('routeObj')).current}}})
    },
    mounted () {
      let token = Vue.ls.get('tss_token')
      if (this.exclusivePricelist === '' && this.exclusivePricelist.length === 0) {
        this.$store.dispatch('GET_EXCLUSIVE_PRICELIST')
      }
      this.$store.commit('SET_LOADING')
      if (this.user && this.user.user_id) {
        this.$store.dispatch('CHECK_EXCLUSIVE_DETAILS', this.user.user_id)
      } else if (token) {
        this.$store.dispatch('USER').then(res => {
          if (res && res.user_id) {
            this.$store.dispatch('CHECK_EXCLUSIVE_DETAILS', res.user_id)
          } else {
            this.$store.commit('UNSET_LOADING', false)
          }
        }, error => {
          console.log(error)
        })
      } else {
        this.$store.commit('UNSET_LOADING', false)
      }
      this.$store.commit('GTAG_EVENT', {eventName: 'page_view',
        payload: {
          sendTo: process.env.GOOGLE_ADWORDS_ID,
          ecomm_pagetype: 'membership',
          page_title: 'membership_page'
        }}
      )
    },
    methods: {
      removeExcFromCart: function (ExcProdid) {
        this.$store.dispatch('UPDATE_CART', {operation: 'delete', name: 'Exclusive', type: 'products', data: {prod_id: ExcProdid}}).then((res) => {})
        this.togglePopup()
        this.exclusiveAdded = false
      },
      smoothScroll (elementId) {
        let elem = document.getElementById(elementId)
        elem.scrollIntoView({block: 'start', behavior: 'smooth'})
      },
      toggleExclusiveBar () {
        if (Vue.ls.get('exclusive') !== 1) {
          let $exclusiveElement = $('.exclusive-topbar')
          $exclusiveElement.slideDown()
          $exclusiveElement.find('.close').on('click', function () {
            $('.navbar-toggleable-md').removeClass('exclusive-fixed')
            $exclusiveElement.slideUp()
            Vue.ls.set('exclusive', 1, 30 * 60 * 1000)
          })
        }
      },
      addExclusive (item) {
        if (!this.isExclusive) {
          let _this = this
          this.$store.dispatch('UPDATE_CART', {type: 'products', operation: 'set', route: _this.$route.fullPath, data: {prod_id: item, quantity: 1, categories: []}}).then(() => {
            _this.toggleExclusiveBar()
            this.exclusiveAdded = true
          })
        } else {
          Vue.toasted.show('Already added to cart', {theme: 'primary', className: 'toasted-customred', position: 'top-right', duration: 5000})
        }
      },
      upgradeMembershipToCart (item) {
        let _this = this
        if (!this.CHECK_PRODUCT_MATCHES) {
          this.$store.dispatch('UPDATE_CART', {type: 'products', name: 'Exclusive', operation: 'set', route: _this.$route.fullPath, data: {prod_id: parseInt(item), quantity: 1, categories: []}}).then((res) => {
          })
        } else {
          Vue.toasted.show('Already added to cart', {theme: 'primary', className: 'toasted-customred', position: 'top-right', duration: 5000})
        }
      },
      addMembershipToCart  (item) {
        if (!this.isExclusive) {
          let _this = this
          this.$store.dispatch('UPDATE_CART', {type: 'products', name: 'Exclusive', operation: 'set', route: _this.$route.fullPath, data: {prod_id: item, quantity: 1, categories: []}}).then(() => {
            // _this.$store.commit('GTAG_EVENT', {eventName: 'exc.membership.added.exc.landing', payload: {exclusive_tracker: this.$route.path}})
            this.$store.dispatch('TATVIC_EVENT', {eventName: 'ADD_MEMBERSHIP_TO_CART',
              payload: {
                exclusive_tracker: this.$route.path
              }}
            )
            let alertConfig = {
              html: true,
              okText: 'Continue Shopping',
              animation: 'fade',
              customClass: 'revamp-exclusive'
            }
            this.$dialog.alert('<div class="congratulation fbold text-center">Congratulations!</div><div class="text-center mt10">The Souled Store Exclusive is added to your cart. You are now shopping at Exclusive prices and have unlocked all benefits.</div>', alertConfig)
              .then(function () {
                _this.$router.push('/')
              })
            _this.toggleExclusiveBar()
          })
        } else {
          Vue.toasted.show('Already added to cart', {theme: 'primary', className: 'toasted-customred', position: 'top-right', duration: 5000})
        }
      },
      bannerAddCart () {
        Vue.toasted.clear()
        Vue.toasted.show('Already added to cart', {theme: 'primary', className: 'toasted-customred', position: 'top-right', duration: 5000})
      },
      togglePopup () {
        if (this.exclusiveUser) {
          Vue.toasted.clear()
          Vue.toasted.show('You are already exclusive member', {theme: 'primary', className: 'toasted-customred', position: 'top-right', duration: 5000})
        } else {
          this.isNotifyVisible = !this.isNotifyVisible
        }
      },
      _setMetaData () {
        this.metaTitle = ('Join The Souled Store Exclusive Membership & Shop At Discounted Prices')
        this.metaDescription = ('Shop for stylish t-shirts, dresses, bags, mobile covers & other products at exclusive discounted prices. Get tees at ₹ 399 and discounts all year round! Join The Souled Store Membership at an introductory price of ₹ 199/ year ONLY.')
        this.metaKeywords = ('the souled store, tss exclusive membership, discounted price, discounts, offers, sale, promo code, voucher, subscribe, subscribers')
      }
    },
    computed: {
      ...mapGetters(['isExclusive', 'exclusiveUser', 'notify', 'site_config', 'exclusivePricelist', 'username', 'user', 'exclusiveDetails', '_cart', 'isLoading', 'bannerPlcaeHolderData', 'memberSavingsTxt', 'currencySymbol']),
      EXCLUSIVE_PRODUCT: function () {
        return this.site_config.exclusive_product
      },
      EXCLUSIVE_PRODUCTS_UPGRADE: function () {
        // if (this.exclusiveDetails.expire_days <= 31) {
        //   return this.site_config.exclusive_products_upgrade.find(upgradeProduct => upgradeProduct.duration > 320)
        // }
        // if (this.exclusiveDetails.expire_days > 31 && this.exclusiveDetails.expire_days <= 90) {
        //   return this.site_config.exclusive_products_upgrade.find(upgradeProduct => upgradeProduct.duration >= 270 && upgradeProduct.duration < 300)
        // }
        if (this.exclusiveDetails && this.exclusiveDetails.show_upgrade_plan) {
          return this.site_config.exclusive_products_upgrade.find(upgradeProduct => upgradeProduct.duration === 365)
        }
      },
      CHECK_PRODUCT_MATCHES: function () {
        let excProduct = this._cart.products.items.find(item => item.category === 'Exclusive')
        if (excProduct) {
          let matchProductId = this.site_config.exclusive_products_upgrade.some(upgradeItem => parseInt(upgradeItem.prod_id) === excProduct.parent_prod_id)
          return matchProductId
        }
        return false
      },
      bannerPlaceHolderExc: function () {
        if (this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length) {
          let OrderBannerObj = this.bannerPlcaeHolderData.find(bannerData =>
            bannerData.placeholder_for.toLowerCase() === 'Exclusive'.toLowerCase() &&
              bannerData.status === true)
          if (OrderBannerObj && Object.keys(OrderBannerObj).length) {
            let OrderBannerPhObj = {}
            OrderBannerPhObj.styles = {
              backgroundColor: OrderBannerObj.banner_color,
              color: OrderBannerObj.banner_text_color
            }
            OrderBannerPhObj.text = OrderBannerObj.tag_text
            OrderBannerPhObj.status = OrderBannerObj.status
            return OrderBannerPhObj
          }
        }
      },
      bannerPlaceHolderForNewExclusiveRevamp: function () {
        const isExclusiveRevampObj = this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length && this.bannerPlcaeHolderData.find(bannerData =>
          bannerData.placeholder_for.toLowerCase() === 'Others'.toLowerCase() && bannerData.status === true && bannerData.product_type.toLowerCase() === 'EXCLUSIVE_REVAMP_NEW'.toLowerCase())
        if (isExclusiveRevampObj) {
          return true
        }
        return null
      }
    }
  }
</script>
<style scoped>
.minHeight{
  min-height: 100vh;
}
</style>
<style>
  .line {
    width: 100%;
    height: 2px;
    background-color: #122643;
    position: relative;
  }

  .execLine  {
    width: 95%;
    height: 3px;
    background-color: #122643;
    position: relative;
  }

  .excBenefitCircle {
    display:inline-block;
    width: 10px;
    height: 10px;
    position: absolute;
    background:#122643;
    left:0;
    right:0;
    border-radius: 100%;
    top:-4px;
  }
  .benefitsHeading {
    color:#e76a52; 
    font-size: 2.2vw;
    display: inline-block;
  }

  .userHead {
    color:#1a1f29; 
    font-size: 34px;
    padding: 0px 15px;
    letter-spacing: normal;
    object-fit: contain;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: normal;
  }

  .crownImg {
    width: 40px;
    margin-left: 10px;
    height: 42px;
    margin-bottom: 7px;
  }

  .crownImgMain {
    width: 75px;
    margin-left: 0px;
    height: 78px;
    margin-bottom: 26px;
  }

  .total-savings-div {
    background: #e66a51;
    margin-top: -30px;
  }

  .total-savings {
    color: #ffffff;
    margin: 0px;
    padding: 2px 15px;
    font-size: 20px;
    font-weight: 600;
    letter-spacing: 0.7px;
    color: #ffffff;
  }

  .exc-mem-info {
    padding: 35px 15px 0px 15px;
  }

  .exc-active-plan, .exc-member-since, .exc-plan-valid-till {
    color:#1a1f29; 
    margin: 0px;
    height: 28px;
    object-fit: contain;
    font-size: 16px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.33;
    letter-spacing: 0.6px;
  }

  .exc-mem-update-head {
    margin-top: 0px;
  }

  .exc-upgrade-plan {
    color:#1a1f29; 
    display: inline;
    border-bottom: 2px solid #1a1f29;
    object-fit: contain;
    font-size: 22px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 3.3;
    letter-spacing: normal;
    text-align: left;
  }

  .exc-mem-update-div {
    background: #ffffff;
    padding: 25px 10px 25px 5px;
    border: 2px #ccc solid;
    border-radius: 5px;
    margin-top: 10px;
  }

  .exc-mem-exceede-time {
    color: #e76a52;
    margin: 0px;
    font-size: 17px;
    text-transform: uppercase;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: 0.8px;
  }

  .exc-mem-update-btn {
    cursor: pointer;
    color: #148c8d;
    font-weight: 600;
    font-size: 18px;
    margin: 0px;
    border-bottom: 2px solid #148c8d;
    display: inline;
  }

  .exc-days-left-head {
    color: #e76a52;
    font-weight: bold;
    font-size: 28px;
    margin: 10px;
  }

  .exc-mem-section-one {
    background-color: #f2f2f2;
    padding: 40px 27px;
    text-align: left;
  }

  .exc-plan-pay-diff {
    font-size: 15px;
    color: #1a1f29;
    object-fit: contain;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: 0.7px;
  }
  
  .cHeading {
    font-size: 18px;
    color: #122643;
  }

  .cDesc {
    color: #aba6a6;
    font-size: 1.1rem;
  }

  .eximg {
    width: 52%;
  }

  .exclusive-features {
    width: 95% !important;
  }

  .exc-mem-heading {
    display: inline-block;
    border-bottom: 2px solid #122643;
    margin-bottom: 40px;
  }

  .exc-days-left {
    font-size: 50px;
    position: absolute;
    top: 35px;
    color: #122643;
    font-weight: bold;
    margin: 0px;
    left: 50%;
    transform: translateX(-50%);
  }

  .days-left {
    position: absolute;
    font-size: 12px;
    top: 100px;
    font-weight: bold;
    margin: 0px;
    left: 50%;
    transform: translateX(-50%);
  }

  /* for mobile view only */
  @media only screen and (max-width: 768px) {
    .exclusive-features {
      width: 100% !important;
    }
    .benefitsHeading {
      font-size: 1.1rem;
    }
    .execLine {
      height: 2px;
    }
    .eximg {
      width:70%;
    }
    .cHeading {
      font-size: 0.9rem;
    }
    .cDesc {
      font-size: 0.7rem;
    }
    .line {
      height: 1px;
    }
    .excBenefitCircle {
      width: 5px;
      height: 5px;
      top: -2px;
    }
    .crownImg {
      width: 22px;
      margin-left: 5px;
      margin-bottom: 7px;
      height: 24px;
    }
  }

  @media only screen 
  and (min-width: 1024px) 
  and (max-height: 1366px) 
  and (-webkit-min-device-pixel-ratio: 1.5) {
    .benefitsHeading {
      font-size: 1.5rem;
    }
  }

  @media only screen and (max-width: 320px) {
    .benefitsHeading {
      font-size: 1rem;
    }
  }



  .dg-content-cont--floating {
    color: #e66a51;
  }

  .dg-main-content:before {
    border: 1px #e66a51 solid;
  }
  .exclusive-revamp .dg-main-content:before {
    border: 1px #fff solid;
  }
  .exclusive-revamp .dg-main-content {
    border-radius: 10px;
  }
  .exclusive-revamp .dg-content-body {
    border-bottom: 2px solid #fff;
  }
  .exclusive-revamp .dg-pull-right {
    float: none;
  }
  .exclusive-revamp .dg-content-footer {
    text-align: center;
  }
  .exclusive-revamp .dg-btn--ok {
    background: #e66a51!important;
    color: #fff !important;
    width: 90%;
  }
  .exclusive-revamp .congratulation {
    font-family: OpenSans-SemiBold !important;
    font-weight: 600 !important;
  }
  .exclusive-revamp .dg-content-cont {
    width: 85% !important;
    top: 25% !important;
  }
  .carousel-item {
    padding: 50px 0 0 !important;
  }
  .exc-card .carousel-indicators {
    margin: 0px auto;
    bottom: -40px;
    max-width: 12px;
  }

  .exc-cat-slider {
    display: flex;
    justify-content: center;
    padding-top: 50px;
  }

  /* The colour of the indicators */
  .exc-card .carousel-indicators li {
    border-radius: 50%;
    width: 12px;
    height: 12px;
    background-color: #646769;
    border: 1px #646769 solid;
    margin: 0px 15px;
  }

  .exc-card .carousel-indicators .active {
    background: #e66a51;
    border: 1px #e66a51 solid;
  }

  a {
    color: inherit;
    cursor: pointer;
  }
  a:hover {
    color: inherit;
  }

  .navver {
    padding-top: 10px;
    height: 45px;
    border-top: 0px;
    margin: 0px 2px 0px 2px;
  }

  .navver:hover {
    border-bottom: 5px solid red;
  }

  .defaultRed {
    border-bottom: 5px solid red;
  }

  .grey {
    color: white;
  }

  .exclusive-wrapper {
    margin: 0 auto;
    text-align: center;
    letter-spacing: 1px;
    padding: 0px !important;
  }
  .member {
    color: #cb5057;
    font-size: 30px;
  }

  .exclusive-card {
    display: inline-block;
    background-color: #117a7a;
    padding: 40px;
    padding-bottom: 25px;
    border-radius: 3px;
    color: white;
    width: 100%;
    max-width: 480px;
    margin-top: 45px;
  }

  .first-line {
    font-size: 25px;
  }

  .second-line {
    font-size: 32px;
  }

  .third-line {
    letter-spacing: 1px;
  }

  .duration {
    color: #ccc;
  }

  .btn-wrapper {
    margin: 28px 0 50px;
  }

  .btn-cart {
    padding: 10px 25px;
    cursor: pointer;
    background: #ed2d2f;
    color: white;
    border-radius: 3px;
    box-shadow: 4px 3px 3px grey;
  }

  .btn-cart:hover {
    background: #a24045;
    border-color: #a24045;
  }

  .capitalize {
    text-transform: capitalize;
  }

  .section-title-wrapper {
    display: block;
    text-align: center;
    overflow: hidden;
    white-space: nowrap;
    font-family: 'Source Sans Pro', sans-serif;
font-weight: 600;
  }

  .section-title-wrapperr {
    text-align: center;
    overflow: hidden;
    white-space: nowrap;
    font-family: 'Source Sans Pro', sans-serif;
font-weight: 600;
  }

  .section-title {
    position: relative;
    display: inline-block;
    font-size: 25px;
    letter-spacing: 8px;
    color: #ed2d2f;
    text-transform: uppercase;
  }

  .section-title-faq {
    position: relative;
    display: inline-block;
    font-size: 25px;
    color: #e66a51;
  }

  .section-price-comparison {
    position: relative;
    display: inline-block;
    font-size: 25px;
    color: #1a1f29;
  }

  .section-title:before, .section-title-faq::before,
  .section-title:after, .section-title-faq:after {
    content: "";
    position: absolute;
    top: 50%;
    width: 9999px;
    height: 1px;
    background: #e66a51;
  }

  .section-title:before, .section-price-comparison::before,
  .section-title:after, .section-price-comparison::after {
    content: "";
    position: absolute;
    top: 50%;
    width: 9999px;
    height: 2px;
    background: #1a1f29;
  }
  .section-title:before, .section-title-faq::before {
    right: 100%;
    margin-right: 15px;
  }

  .section-title:after, .section-title-faq::after {
    left: 100%;
    margin-left: 15px;
  }

  .section-title:before, .section-price-comparison::before {
    right: 100%;
    margin-right: 15px;
  }

  .section-title:after, .section-price-comparison::after {
    left: 100%;
    margin-left: 15px;
  }

  .hr-exclusive {
    border-color: #cb5057;
    margin-bottom: 40px;
  }

  /* Header */

  .birthday-logo.exclusive .navbar-brand {
    background: url('https://tss-static-images.gumlet.io/exclusive/TSS_Logo_Birthday_exclusive.png') center center no-repeat;
    background-size: contain;
  }

  .birthday-logo .exclusive .navbar-brand {
    background: url('https://tss-static-images.gumlet.io/exclusive/TSS_Logo_Birthday_exclusive.png') center center no-repeat;
    background-size: contain;
  }

  .exclusive .navbar.fixed-top .navbar-brand {
    background: url('https://prod-img.thesouledstore.com/public/theSoul/images/exclusive/MemebrIcon_On.png') center center no-repeat;
    background-size: contain;
  }

  .birthday-logo.exclusive .navbar.fixed-top .navbar-brand {
    background: url('https://tss-static-images.gumlet.io/exclusive/TSS_Logo_Birthday_exclusive.png') center center no-repeat;
    background-size: contain;
  }

  .birthday-logo .exclusive .navbar.fixed-top .navbar-brand {
    background: url('https://tss-static-images.gumlet.io/exclusive/TSS_Logo_Birthday_exclusive.png') center center no-repeat;
    background-size: contain;
  }
  .exclusive-congrats-msg {
    color: #e76a52;
    font-size: 40px;
    font-weight: bold;
    padding: 100px 0px;
  }
  .exclusive .navbar-brand:before {
    filter: brightness(0%);
    -webkit-filter: brightness(0%);
  }


  .exclusive .navbar-brand:not(.slidem):before {
    left: 34px;
    width: 18px;
    top: 22px;
  }

  .exclusive .search input#search {
    padding-left: 50px;
  }

  .exclusive .new-search input#search {
    padding-left: 15px;
  }

  .price-list {
    max-width: 600px;
    margin: auto;
  }

  .exclusive .mbinput {
    background: #0a141e;
  }

  .add-to-cart {
    display: none;
    border: none;
    z-index: 9;
  }

  .exc-section-one {
    background-color: #e76a52;
    padding: 110px 0px 90px 0px;
  }

  .exc-section-two {
    background-color: #fff;
  }

  .exc-section-three-wrapper {
    background-color: #fff;
    padding: 50px 0px 50px 0px;
    margin-bottom: -1px;
  }

  .click-to-add {
    cursor: pointer;
  }

  .sec-one-discount-header {
    color: #ffffff;
    font-size: 70px;
    font-weight: bold;
  }
  
  .sec-one-discount-content {
    color: #fff;
    font-size: 30px;
    font-weight: bold;
  }

  .exc-member-banner {
    background-color: #e76a52;
  }

  .exc-saving {
    padding: 20px 0px;
  }

  .exc-saving .saving-msg {
    color: #fff;
    font-size: 25px;
    font-weight: bold;
    margin: 0px;
  }

  .exc-features-section {
    background-color: #fff;
    margin-bottom: -1px;
  }

  .exc-discounted-price-section {
    padding-bottom: 60px;
  }

  .exc-discounted-price-section .exc-discount-heading {
    font-size: 30px;
    font-weight: bold;
    color: #e66a51;
    margin: 0px;
    line-height: 32px;
  }

  .exc-discounted-price-section .discount-price-img {
    padding-top: 82.5px;
  }

  .exc-discounted-lower-section {
    padding: 30px 0px;
  }

  .exc-discounted-lower-section .lower-section-col {
    border-left: 1px #a9aaa9 solid;
    border-right: 1px #a9aaa9 solid;
  }

  .early-access-content {
    color: #e66a51;
    font-weight: bold;
    font-size: 20px;
    margin: 0px;
    line-height: 30px;
  }

  .exc-discounted-lower-section .early-access-img,
  .exc-discounted-lower-section .prioritised-order-img,
  .exc-discounted-lower-section .free-delivery-img {
    width: 120px;
    height: 75px;
    margin-bottom: 20px;
  }

  .exc-faqs-section {
    padding-top: 60px;
    background-color: #fff;
    padding: 0px;
    margin: 0px;
    padding-bottom: 100px;
  }

  .exc-faqs-section .exc-faqs-section-col {
    padding: 0px !important;
  }

  .exc-cat-card {
    margin: 0px;
    padding: 0px;
  }

  .cards-row {
    display: flex;
    justify-content: space-between;
  }

  @media screen and (max-width: 991px) {
    .exclusive .navbar.fixed-top .navbar-brand {
      width: 52px !important;
    }

    .exclusive .navbar-brand.slidem {
      background: url('https://prod-img.thesouledstore.com/public/theSoul/images/exclusive/MemebrIcon_On.png') center center no-repeat !important;
    }
    .exclusive .navbar-brand:not(.slidem):before {
      left: 19px;
      width: 15px;
      top: 25px;
      background-size: 85% auto;
    }
    .exclusive .exclusive-fixed {
      top: 40px;
    }
    .section-title {
      font-size: 22px;
    }

    .exclusive-card {
      margin-top: 25px;
      padding: 20px 40px;
      width: auto;
    }

    .add-to-cart {
      display: block;
      color: #ccc;
      margin-bottom: 0;
      background: #90050d;
    }

    .hr-exclusive {
      display: none;
    }


    .exclusive .navbar.fixed-top {
      padding: 0 10px;
    }

    .exclusive .faq-link {
      display: block;
    }
  }
  .congratulation {
    font-size: 24px;
  }


  @media screen and (max-width: 992px) {
    .navbar.fixed-top .navbar-brand::before {
          width: 12px !important;
          background-size: 80% auto;
          left: 8px;
    }

   
  .exclusive .navbar-brand:not(.slidem):before {
    left: 20px;
    width: 12px;
    top: 27px;
    background-size: 80% auto;
    }
    


    .navbar.fixed-top .navbar-brand {
    height: 62px !important;;
    width: 60px !important;;
    bottom: 1px;
    position: absolute !important;
    left:0;
    top: -10px;
  }
    h5 {
      font-size: 16px;
    }

    .navver {
      padding-top: 1%;
    }

    .mobileMarginRight {
      margin-right: 0;
    }
    .mobileMarginLeft {
      margin-left: 0;
    }
  }

  @media screen and (min-width: 991px) {
    .is_Mobile {
      display: none;
    }
    .is_Desktop {
      display: block; 
    }
  }

  @media screen and (max-width: 991px) {
    .is_Desktop {
      display: none;
    }
    .is_Mobile {
      display: block;
    }
    .mobile_carousel {
      display: flex;
      overflow-x: scroll;
      flex-wrap: nowrap;
      padding: 50px 0px 0px 0px;
    }
  }


  @media screen and (max-width: 768px) {
    .exc-section-one {
      padding: 35px 0px 40px 0px;
    }

    .sec-one-discount-header {
      font-size: 40px;
    }
    
    .sec-one-discount-content {
      font-size: 17px;
    }
    .exclusive-congrats-msg {
      font-size: 30px;
      padding: 50px 0px 80px 0px;
    }

    .exc-section-three-wrapper {
      padding: 25px 0px 20px 0px;
    }

    .exc-discounted-price-section .discount-price-img {
      padding-top: 41px;
    }

    .exc-discounted-lower-section .early-access-img,
    .exc-discounted-lower-section .prioritised-order-img,
    .exc-discounted-lower-section .free-delivery-img {
      width: 70px;
      height: 50px;
      margin-bottom: 20px;
    }

    .early-access-content {
      font-size: 14px;
      line-height: 20px;
    }
    .section-price-comparison {
      font-size: 20px;
    }

    .exc-discounted-price-section {
      padding-bottom: 35px;
    }

    .exc-mem-upgrade-plan {
      position: relative;
      display: inline-block;
      font-size: 16px;
      color: #1a1f29;
      font-weight: bold;
      margin-bottom: 10px;
    }

    .exc-mem-section-one {
      padding: 0px;
    }

    .crownImgMain {
      width: 40px;
      height: 43px;
      margin: 0px;
    }

    .userHead {
      text-align: center;
    }

    .total-savings-div {
      margin: 0px;
      text-align: center;
    }

    .total-savings {
      font-size: 14px;
      padding: 10px 0px;
    }

    .exc-mem-name {
      font-size: 25px;
      margin: -5px 0px 5px 0px;
    }

    .exc-mem-info {
      padding: 20px 0px 0px 0px;
      text-align: center;
    }

    .exc-active-plan, .exc-member-since, .exc-plan-valid-till {
      font-size: 15px;
      font-weight: normal;
    }

    .exc-mem-update-head {
      margin-top: 15px;
    }

    .exc-mem-update-div {
      margin: 0px 15px;
      padding: 20px 2px;
    }

    .exc-mem-exceede-time {
      text-align: start;
    }

    .exc-mem-exceede-time {
      font-size: 14px;
    }
    
    .exc-mem-update-btn {
      font-size: 12px;
    }

    .exc-plan-pay-diff {
      font-size: 9.5px;
    }

    .exc-days-left-head {
      font-size: 14px;
      border-bottom: 2px solid black;
      display: inline;
      margin: 10px;
    }

    .exc-mem-tracker {
      background: #ffffff;
    }

    .exc-mem-upgrade-plan::after {
      left: 100%;
      margin-left: 5px;
    }

    .exc-mem-upgrade-plan::before {
      right: 100%;
      margin-right: 5px;
    }

    .exc-mem-upgrade-plan::before,
    .exc-mem-upgrade-plan::after {
      content: "";
      position: absolute;
      top: 50%;
      width: 28%;
      height: 2px;
      background: #1a1f29;
    }

    .exc-days-left {
      font-size: 45px;
      top: 35px;
    }

    .days-left {
      font-size: 10px;
      top: 95px;
    }
  }

  @media screen and (max-width: 576px) {
    .exc-mem-exceede-time {
      font-size: 13px;
    }
  }

  @media screen and (max-width: 414px) {
    .exclusive-congrats-msg {
      font-size: 23px;
      padding: 30px 0px 60px 0px;
    }

    .exc-saving .saving-msg {
      font-size: 15px;
    }
    .exc-mem-exceede-time {
      font-size: 13px;
    }
  }

  @media screen and (max-width: 375px) {
    .exclusive-congrats-msg {
      font-size: 21px;
    }
    .exc-mem-exceede-time {
      font-size: 11px;
    }
  }
  @media screen and (max-width: 360px) {
    .exclusive-congrats-msg {
      font-size: 20px;
    }
  }
  @media screen and (max-width: 320px) {
    .exc-saving .saving-msg {
      font-size: 13px;
    }
    .exclusive-card {
      padding: 20px;
    }
    .exc-saving {
      padding: 18px 0px;
    }
    .exclusive .exclusive-topbar {
      font-size: 12px !important;
    }
    .exclusive-congrats-msg {
      font-size: 17px;
    }
    .exclusive .container-fluid {
      padding-left: 5px;
      padding-right: 5px;
    }
    .exc-mem-exceede-time {
      font-size: 9px;
    }
  }

</style>



// WEBPACK FOOTER //
// exclusive.vue?d44a522a